module.exports = __webpack_public_path__ + "static/media/notification.e8f636d5.svg";